<div class="modal-container">
    <div class="modal fade location-preference-modal" tabindex="-1" role="dialog" #locationPreferenceModal>
      <div class="modal-dialog">
        <div class="modal-content" [ngClass]="confirmModal?'modal-content-confirmation':'modal-content-custom'">
          <div class="modal-header">
            <div class="modal-title">{{modalHeader}}</div>
            <div class="closeModal">  
              <div type="button" class="close nr-icon nr-close" data-dismiss="modal" (click)="close()">
                <span>x</span>
              </div>
            </div>
          </div>
          <div class="modal-body">
              <ng-content></ng-content>
          </div>
         
          <div class="modal-footer footerBtn">
            <!-- <ng-content select="[modalFooter]"></ng-content> -->
            <div class="footerBtnSection">
              <ng-container *ngIf="!singleBtn">
                <div class="btnitem cancelBtn">
                  <div class="btn btn-close"  (click)="close()" >
                    <span>Cancel</span>
                  </div>
                </div>
                <div class="btnitem acceptBtn">
                  <div class="btn btn-accept"  (click)="onApply()" >Apply</div>
                </div>
              </ng-container>
  
              <ng-container *ngIf="singleBtn">
                <div class="btnitem doneBtn">
                  <div class="btn btn-close"  (click)="close()" >
                    <span>Done</span>
                  </div>
                </div>
              </ng-container>
             
             
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
